/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";

class ActivityItem extends Component {
  rowClassName = "";

  state = {
    showingTabletDetail: false,
  };

  toggleTabletDetail = () => {
    let showing = this.state.showingTabletDetail;
    this.setState({ showingTabletDetail: !showing });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };
  renderTabletModeDetail = (t) => {
    if (!this.state.showingTabletDetail) return null;

    return (
      <tr className="child">
        <td className="child" colspan="3">
          <table>
            <tr data-dt-row="0" data-dt-column="5">
              <td>
                <div className="tableTitle">
                  <Trans desc="Pozisyon İsmi">10064</Trans>
                </div>
              </td>
              <td>{t.position?.name}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="6">
              <td>
                <div className="tableTitle">
                  <Trans desc="Rapor Ettiği Çalışan">10072</Trans>
                </div>
              </td>
              <td>{t.reportPersonel?.name}</td>
            </tr>
            <tr data-dt-row="0" data-dt-column="7">
              <td>
                <div className="tableTitle">
                  <Trans desc="Durum">10018</Trans>
                </div>
              </td>
              <td>{t.isApprovedCode?.label}</td>
            </tr>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { act } = this.props;

    return (
      <>
        <DesktopBreakpoint>
          <tr className={this.rowClassName}>
            <td className="showGrup">{this.renderDate(act.date)}</td>
            <td className="showGrup">{act.type ? act.type.label : ""}</td>
            <td className="showGrup">
              {act.employee ? act.employee.name : ""}
            </td>
            <td className="showGrup">
              {act.position ? act.position.name : ""}
            </td>
            <td className="showGrup">
              {act.reportPersonel ? act.reportPersonel.name : ""}
            </td>
            <td className="showGrup">
              {act.isApprovedCode ? act.isApprovedCode.label : ""}
            </td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr className={this.rowClassName} onClick={this.toggleTabletDetail}>
            <td className="showGrup">{this.renderDate(act.date)}</td>
            <td className="showGrup">{act.type ? act.type.label : ""}</td>
            <td className="showGrup">
              {act.employee ? act.employee.name : ""}
            </td>
          </tr>
          {this.renderTabletModeDetail(act)}
        </TabletBreakpoint>
      </>
    );
  }
}

export default ActivityItem;
